import {Fragment} from "react";
import {formatPeriodLabel} from "../../../../general/DateRangeInput/utils/dateRangeUtils.ts";
import type {ComparisonPeriod} from "../../types";
import {COL_SEP_L, COL_SEP_R, type AmountGroup} from "./tableStyles.ts";

interface StatementTableHeaderProps {
    isSlim: boolean;
    hasComparison: boolean;
    comparisonPeriod: ComparisonPeriod | null;
    groups: AmountGroup[];
    accountColumnRowSpan: number;
}

export function StatementTableHeader({
    isSlim,
    hasComparison,
    comparisonPeriod,
    groups,
    accountColumnRowSpan,
}: StatementTableHeaderProps) {
    const comparisonLabel = comparisonPeriod
        ? `Vergelijking ${formatPeriodLabel(comparisonPeriod.start_date, comparisonPeriod.end_date)}`
        : "Vergelijking";

    return (
        <thead>
            <tr className="bg-gray-50">
                <th
                    rowSpan={accountColumnRowSpan}
                    className={`sticky left-0 z-20 px-3 py-3 text-left text-[13px] font-semibold text-gray-900 ${COL_SEP_R} bg-gray-50 min-w-[280px]`}
                >
                    Rekening
                </th>
                {isSlim ? (
                    <th
                        rowSpan={accountColumnRowSpan}
                        className="px-3 py-3 text-right text-[13px] font-bold text-gray-900"
                    >
                        Bedrag
                    </th>
                ) : (
                    groups.map((group, index) => (
                        <th
                            key={group.bucket}
                            colSpan={2}
                            className={`px-3 py-2 text-center text-[13px] font-bold text-gray-900 ${
                                index === 0 ? "" : COL_SEP_L
                            }`}
                        >
                            {group.label}
                        </th>
                    ))
                )}
                {hasComparison && (
                    <th
                        colSpan={isSlim ? 2 : 3}
                        className={`px-3 py-2 text-center text-[13px] font-bold text-gray-900 ${COL_SEP_L} whitespace-nowrap`}
                    >
                        {comparisonLabel}
                    </th>
                )}
            </tr>
            {(!isSlim || hasComparison) && (
                <tr className="bg-gray-50">
                    {!isSlim &&
                        groups.map((group, index) => (
                            <Fragment key={group.bucket}>
                                <th
                                    className={`px-3 py-2 text-right text-[11px] font-normal text-gray-500 ${
                                        index === 0 ? "" : COL_SEP_L
                                    }`}
                                >
                                    Debet
                                </th>
                                <th className="px-3 py-2 text-right text-[11px] font-normal text-gray-500">
                                    Credit
                                </th>
                            </Fragment>
                        ))}
                    {hasComparison &&
                        (isSlim ? (
                            <>
                                <th
                                    className={`px-3 py-2 text-right text-[11px] font-normal text-gray-500 ${COL_SEP_L}`}
                                >
                                    Saldo
                                </th>
                                <th className="px-3 py-2 text-right text-[11px] font-normal text-gray-500">
                                    Δ %
                                </th>
                            </>
                        ) : (
                            <>
                                <th
                                    className={`px-3 py-2 text-right text-[11px] font-normal text-gray-500 ${COL_SEP_L}`}
                                >
                                    Debet
                                </th>
                                <th className="px-3 py-2 text-right text-[11px] font-normal text-gray-500">
                                    Credit
                                </th>
                                <th className="px-3 py-2 text-right text-[11px] font-normal text-gray-500">
                                    Δ %
                                </th>
                            </>
                        ))}
                </tr>
            )}
        </thead>
    );
}
